import { Buildings, Code, GlobeHemisphereWest } from "@phosphor-icons/react";
import { createIMessage } from "@/lib/utils";
import { IChat } from "@/lib/types";
import { v7 as uuidv7 } from "uuid";
import React from "react";
import { CurrentChatContext } from "@/components/context";
import { AuthenticatedTemplate } from "@azure/msal-react";

export const MainDefault = () => {
    const { updateCurrentChat } = React.useContext(CurrentChatContext);
    const currentMonthName = new Date().toLocaleString("default", { month: "long" });
    const updateSample = (sampleMessage: string) => {
        const message = createIMessage("user", sampleMessage);
        const newChat: IChat = {
            timestamp: Date.now(),
            id: uuidv7(),
            messages: [message],
        };
        updateCurrentChat(newChat);
    };
    return (
        <>
            <div className={"max-w-3xl mx-auto pt-4 lg:pt-8 px-2 lg:px-8"}>
                <div className={"bg-zinc-200/75 rounded-xl p-4 px-4 lg:px-8"}>
                    <div className={"text-xl font-bold pb-4"}>
                        Welcome to the Fender Intelligence Agent!
                    </div>
                    <div className={"text-sm text-zinc-900/70"}>
                        <p className={"pb-4"}>
                            To get started, just type in a message and hit enter or click the send
                            button. The agent is safe for all employees to use &mdash;{" "}
                            <b className={"text-zinc-900"}>
                                all data stays within the Fender environment.
                            </b>
                        </p>
                        <p>
                            The agent is still <b className={"text-zinc-900"}>experimental</b> and
                            may not always give the correct response. The model it uses (Claude 3.7
                            Sonnet) is trained only up to February 2025, so it will have difficulty
                            answering time-sensitive questions.
                        </p>
                        <p className={"pt-4 pb-2"}>
                            Questions or comments? Please contact{" "}
                            <a
                                className="underline hover:no-underline"
                                href={"mailto:mbeeson@fender.com"}
                            >
                                Mark Beeson
                            </a>
                            .
                        </p>
                    </div>
                </div>
                <AuthenticatedTemplate>
                    <div className={"pt-8 pb-4 text-sm text-zinc-900/50 text-center"}>
                        Sample starter messages:
                    </div>
                    <div className={"flex flex-col lg:flex-row items-stretch"}>
                        <div
                            className={
                                "cursor-pointer text-sm lg:mr-2 px-4 pt-2 pb-3 basis-1/3 bg-blue-100 rounded-lg hover:bg-blue-200 transition-colors"
                            }
                            onClick={() =>
                                updateSample("What are the major product lines at Fender?")
                            }
                        >
                            <Buildings size={24} className={"mb-1"} />
                            What are the major product lines at Fender?
                        </div>
                        <div
                            className={
                                "cursor-pointer text-sm mt-2 mb-2 lg:mt-0 lg:mb-0 lg:mr-2 lg:ml-2 px-4 pt-2 pb-3 basis-1/3 bg-blue-100 rounded-lg hover:bg-blue-200 transition-colors"
                            }
                            onClick={() =>
                                updateSample(
                                    `What is the weather usually like in Ensenada in ${currentMonthName}?`
                                )
                            }
                        >
                            <GlobeHemisphereWest size={24} className={"mb-1"} />
                            What is the weather usually like in Ensenada in {currentMonthName}?
                        </div>
                        <div
                            className={
                                "cursor-pointer text-sm lg:ml-2 px-4 pt-2 pb-3 basis-1/3 bg-blue-100 rounded-lg hover:bg-blue-200 transition-colors"
                            }
                            onClick={() =>
                                updateSample(
                                    "Write an AWS Lambda function that will output the current date and time."
                                )
                            }
                        >
                            <Code size={24} className={"mb-1"} />
                            Write an AWS Lambda function that will output the current date and time.
                        </div>
                    </div>
                </AuthenticatedTemplate>
            </div>
        </>
    );
};
